/* eslint-disable */
import { CompanyListItemAttributes } from 'kosmos/models';
import {
  FilterItemDto,
  KosmosReportDto,
  CompanyListDto,
  CompanyListCompanyDto,
  CompanyListShortListDtoQueryResultDto,
  CompanyListCompanyShortDtoQueryResultDto,
  CreateCompanyListItemRequestDto,
  BulkStatusDto,
} from 'models/dtoTypes';
import { getCompanyListsApi } from 'services';
import { processResponse } from './openapiClient';

export const GetCompanyLists = async (options: {
  pageIndex: number;
  fullTextSearch?: string;
  filters?: FilterItemDto[];
  sortColumn?: string;
  isDesc?: boolean;
}): Promise<CompanyListShortListDtoQueryResultDto> => {
  const client = await getCompanyListsApi();
  const response = await client.getCompanyLists(options);
  return response.data;
};

export const ScoreCompanyList = async (id: string): Promise<CompanyListDto> => {
  const client = await getCompanyListsApi();
  const response = await client.scoreCompanyList(id);
  return response.data;
};

export const GetEsgReportData = async (id: string): Promise<KosmosReportDto[]> => {
  const client = await getCompanyListsApi();
  const response = await client.getEsgReportData(id);
  return response.data;
};

export const TriggerRescoringCompanyList = async (
  companyListCompanyIds: string[],
  companyListId: string,
): Promise<string> => {
  const client = await getCompanyListsApi();
  const response = await client.triggerRescoringCompanyListByCompanyListCompanyIds({
    companyListCompanyIds,
    companyListId,
  });
  return response.data;
};

export const LinkCompany = async (
  id: string,
  companyListCompanyId: string,
  companyIds: string[],
): Promise<CompanyListCompanyDto> => {
  const client = await getCompanyListsApi();
  const response = await client.linkCompany(id, {
    companyIds,
    companyListCompanyId,
  });
  return response.data;
};

export const GetCompanyListItems = async (
  companyListId: string,
  options: {
    pageIndex: number;
    filters?: FilterItemDto[];
    sortColumn?: string;
    isDesc?: boolean;
  },
): Promise<CompanyListCompanyShortDtoQueryResultDto> => {
  const client = await getCompanyListsApi();
  const response = await client.getCompanyListItems(companyListId, options);
  return response.data;
};

export const GetCompanyList = async (id: string): Promise<CompanyListDto> => {
  const client = await getCompanyListsApi();
  const response = await client.getCompanyList(id);
  return response.data;
};

export const GetCompanyListStatus = async (id: string): Promise<BulkStatusDto> => {
  const client = await getCompanyListsApi();
  const response = await client.getCompanyListStatus(id);
  return response.data;
};
export const UpdateCompanyList = async (
  id: string,
  attrs: {
    name?: string;
    description?: string;
  },
): Promise<CompanyListDto> => {
  const client = await getCompanyListsApi();
  const res = await client.updateCompanyList(id, attrs);
  return res.data as CompanyListDto;
};

export const CreateCompanyList = async (requestBody: {
  name: string;
  description: string;
}): Promise<CompanyListDto> => {
  const client = await getCompanyListsApi();
  const response = await client.createCompanyList(requestBody);
  return response.data;
};

export const ReorderCompanyListItem = async (
  listId: string,
  itemIds: string[],
): Promise<CompanyListDto> => {
  const client = await getCompanyListsApi();
  const response = await client.reorderCompanyListItem(listId, itemIds);
  return response.data;
};

export const ReplaceCompanyListItems = async (
  listId: string,
  records: CreateCompanyListItemRequestDto[],
): Promise<CompanyListDto> => {
  const client = await getCompanyListsApi();

  try {
    const response = await client.replaceCompanyListItems(listId, records);
    return processResponse<CompanyListDto>(response);
  } catch (e) {
    console.log(e);
    return processResponse<CompanyListDto>(e);
  }
};

export const CreateOrUpdateCompanyListItem = async (
  listId: string,
  attrs: CompanyListItemAttributes,
): Promise<CompanyListCompanyDto> => {
  const client = await getCompanyListsApi();
  const response = await client.createCompanyListItem(listId, attrs);
  return response.data;
};

export const DeleteCompanyListItem = async (id: string, itemId: string): Promise<void> => {
  console.log(id, itemId);
  const client = await getCompanyListsApi();
  await client.deleteCompanyListCompany(id, itemId);
};
